import { useState } from 'react';
import LIVR         from 'livr';

import api          from '../../../singleton/api.js'

const validator = new LIVR.Validator({
    firstName        : [ 'required' ],
    lastName         : [ 'required' ],
    email            : [ 'required', 'email' ],
    companyName      : [ 'required' ],
    message          : [ 'required' ]
});

function useContactPage(captchaRef) {
    const [ values, setValues ] = useState({});
    const [ errors, setErrors ] = useState({});
    const [ isSaveLoading, setSaveLoading ] = useState(false)

    function handleChange(name) {
        return (e) => {
            const value = e.target.value;
            
            setValues(prev => ({
                ...prev,
                [name]: value
            }));

            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    async function handleSubmit() {
        setSaveLoading(true);
        const validData = validator.validate(values);

        if(validData) { 
            try {
                const captchaKey = await captchaRef.current.executeAsync();
                
                await api.account.contactUs(validData, { captchaKey })
            } catch(err) {
                console.log(err)
            } finally {
                setSaveLoading(false)
            }
        } else {
            const err = validator.getErrors();

            setErrors(err);
            setSaveLoading(false);
        } 
    }

    return {
        handleChange,
        handleSubmit,
        isSaveLoading,
        values,
        errors
    };
}

export default useContactPage;
